// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1whm-","colCheckbox":"styles_colCheckbox__3gtz9"};